import styles from "../styles/LandingPage.module.scss";
import toptriangle from "../assets/portfoliotriangles/top.png";
import sidetriangle from "../assets/portfoliotriangles/leftcorner.png";
import righttriangle1 from "../assets/portfoliotriangles/characterback.png";
import righttriangle2 from "../assets/portfoliotriangles/characterfront.png";
import portfoliogirl from "../assets/portfoliocharacter.png";
import github from "../assets/socialicons/github.svg";
import Work from "../components/LandingPage/Work";
import Writings from "../components/LandingPage/Writings";
import Footer from "../components/Footer/Footer";

const Landingpage = () => {
  return (
    <>
      <div className={styles.landinpage}>
        <img src={toptriangle} alt="top triangle" />
        <img src={sidetriangle} alt="left triangle" />
        <div>
          <h1>I’m a Full Stack Developer,</h1>
          <img src={righttriangle1} alt="right bottom triangle" />
          <img src={righttriangle2} alt="tight top triangle" />
          <img src={portfoliogirl} alt="portfolio" />
        </div>
        <p>
          Making a website is piece of cake for me And i love making cakes. Need
          a website? I’m in!
        </p>
        <a href="https://github.com/riddhisiddarkar">
          <img src={github} alt="github" />
          My Github
        </a>
      </div>
      <Work />
      <Writings />
      <Footer title="About Us" />
    </>
  );
};

export default Landingpage;
